
// simple class-toggling plugin
jQuery.toggle_class = jQuery.fn.toggle_class = function( toggleClass ) {
  if( jQuery(this).hasClass(toggleClass) ){
    jQuery(this).removeClass(toggleClass);
  } else {
    jQuery(this).addClass(toggleClass);
  };
};

// simple class-swapping plugin
jQuery.swap_class = jQuery.fn.swap_class = function( classA, classB ) {
  if( jQuery(this).hasClass(classA) ){
    jQuery(this).removeClass(classA).addClass(classB);
  } else {
    jQuery(this).removeClass(classB).addClass(classA);
  };
};


// Equal heights in a given row
jQuery.equal_heights = jQuery.fn.equal_heights = function( args ) {

  var actual_target = ( args.target == false ) ? jQuery(this) : jQuery(args.target, this);
  var tallest = 0;

  for ( var i = 0; i < actual_target.length; i++ ) {
    var tester = actual_target[i];
    var test_height = jQuery(tester).innerHeight();
    tallest = ( test_height >= tallest ) ? test_height : tallest;
  };

  jQuery(actual_target).css('height', (tallest) + "px" );

};

// Cookie handlers from https://www.quirksmode.org/js/cookies.html
function createCookie( name, value, days ) {

  if (days) {

    var date = new Date();

    date.setTime( date.getTime() + ( days*24*60*60*1000 ) );

    var expires = "; expires="+date.toGMTString();

  }

  else var expires = "";

  document.cookie = name + "=" + value + expires + "; path=/";

} // / createCookie


function readCookie( name ) {

  var nameEQ = name + "=";

  var ca = document.cookie.split(';');

  for( var i = 0; i < ca.length; i++ ) {

    var c = ca[i];

    while (c.charAt(0)==' ') c = c.substring(1,c.length);

    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);

  } // / for loop

  return null;

} // / readCookie


function eraseCookie( name ) {

  createCookie( name, "", -1 );

} // / eraseCookie
